import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

import { NecModalService } from '../../service/modal/modal.service';

@Component({
  selector: 'nec-office-preview',
  templateUrl: './office-preview.component.html',
  styleUrls: ['./office-preview.component.scss']
})
export class NecOfficePreviewComponent implements OnInit {

  @Input() iframeSrc: any;
  @Input() wrapped: boolean;
  @Output() closePreview: EventEmitter<any> = new EventEmitter();

  constructor(private modal: NecModalService) {
  }
  
  ngOnInit() {
  }

  close() {
    this.closePreview.emit();
  }
}